import { render, staticRenderFns } from "./GuoDoctorPage.vue?vue&type=template&id=db2ce63e&scoped=true"
import script from "./GuoDoctorPage.vue?vue&type=script&lang=js"
export * from "./GuoDoctorPage.vue?vue&type=script&lang=js"
import style0 from "./GuoDoctorPage.vue?vue&type=style&index=0&id=db2ce63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2ce63e",
  null
  
)

export default component.exports